<template>
  <div class="option-info">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/styles/functions" as *;

.option-info {
  font-size: px2rem(12px);
  line-height: 1.4;
  color: #333;
}

:slotted(p) {
  margin-top: .5em;
}
</style>
